// ------------ GLOBAL JS ------------ //

window.$ = window.jQuery = require('jquery');
require('bootstrap-sass');
window.iziToast = require('izitoast');
window.Vue = require('vue');
window.axios = require('axios');
window.MobileDetect = require('mobile-detect');
window.debounce = require('debounce');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('../sw.js');

let token = $('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.attr('content');

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': token.attr('content')
        }
    });
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

$(document).ready(function () {
    navbarOnMobile();

    $(window).resize(function () {
        navbarOnMobile();
    });
});

if (!window.getZIndexes) {
    window.getZIndexes = function () {
        let allElems = document.querySelectorAll('body *');
        let data = [];
        for (let i = 0; i < allElems.length; i++) {
            let zIndex = parseFloat(window.getComputedStyle(allElems[i]).zIndex);
            let elemClass = allElems[i].className;
            let elemId = allElems[i].id;
            let elemTag = allElems[i].tagName;

            if (!Number.isNaN(zIndex)) {
                data.push({
                    zIndex: zIndex,
                    elemClass: elemClass,
                    elemId: elemId,
                    elemTag: elemTag
                });
            }
        }

        console.table(data);
    };
}

function navbarOnMobile() {
    if (screen.width > 767) {
        return;
    }

    $('.navbar-collapse li.has-submenu > a').click(function () {
        $('.navbar-collapse li.has-submenu').each(function (index, el) {
            $(el).find('ul').addClass('sub-menu-hidden');
        });

        $(this).closest('.has-submenu').find('ul').removeClass('sub-menu-hidden');
    });
}

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {

            if (!(el == event.target || el.contains(event.target))) {

                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});

// ------------ END GLOBAL JS ------------ //

require('lightgallery'); // Size - 18kB
require('jquery-plainoverlay');
require('../scripts.js');
require('./sidemap.js');
import VModal from 'vue-js-modal';
import StarRating from 'vue-star-rating';

const eventHub = new Vue();

Vue.mixin({
    data: function () {
        return {
            eventHub: eventHub
        };
    }
});

Vue.use(VModal);

Vue.prototype.$http = axios;

Vue.component('star-rating', StarRating);
Vue.component('lazy-load', require('../components/LazyLoad.vue'));
Vue.component('load-more', require('../components/LoadMore.vue'));

// ------------ HOME PAGE ------------ //
Vue.component('get-video', require('../components/Video.vue'));
Vue.component('home-search', require('../components/HomeSearch.vue'));
// ------------ END HOME PAGE ------------ //

// ------------ RESTAURANTS LISTING ------------ //
Vue.component('restaurant-search', require('../components/RestaurantSearch.vue'));
Vue.component('search-rating', require('../components/RestaurantSearchRating.vue'));
Vue.component('search-terms', require('../components/SearchTerms.vue'));
Vue.component('search-amenities', require('../components/RestaurantSearchAmenities.vue'));
Vue.component('search-range', require('../components/RestaurantSearchRange.vue'));
// ------------ END RESTAURANTS LISTING ------------ //

// ------------ RESTAURANTS PAGE ------------ //
Vue.component('restaurant-list-dishes', require('../components/ListDishesOnRestaurant.vue'));
// Vue.component('feedback-v2', require('../components/FeedbackV2'));
Vue.component('modal-trigger', require('../components/ModalTrigger.vue'));
Vue.component('flat-map', require('../components/FlatMap.vue'));
Vue.component('restaurant-map', require('../components/RestaurantMap.vue'));
Vue.component('foodmash-deck', require('../components/FoodmashDeck.vue'));
// ------------ END RESTAURANTS PAGE ------------ //

Vue.filter('str_limit', function (value, limit) {
    if (!value) {
        return '';
    }

    value = value.toString();

    if (value.length <= limit) {
        return value;
    }

    return value.substring(0, limit) + '...';
});

Vue.filter('ucfirst', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('strip_tags', function (value) {
    if (!value) {
        return '';
    }

    return value.replace(/(<([^>]+)>)/gi, '');
});

Vue.filter('keyword_search_url', function (value, keyword) {
    if (!value) {
        return '';
    }

    keyword = keyword.toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '');

    return value + keyword;
});

new Vue({
    el: '#vue_id'
});

window.readMore = function readMore(el, button, height = null, containerLink = null) {
    if (el.height() > height) {
        el.css({
            'position': 'relative',
            'overflow': 'hidden',
            'height': height + 'px'
        });

        let readMoreContainer;

        if (containerLink) {
            readMoreContainer = '<a href="' + containerLink + '" class="read-more-container" style="text-decoration: none; outline: none;"></a>';
        } else {
            readMoreContainer = '<div class="read-more-container"></div>';
        }

        el.append($(readMoreContainer).html(button));
    }
};

window.scrollOnTabsToMainContent = function scrollOnTabsToMainContent(duration = 2000, offset = 140) {
    let withTimeout = true;

    if (screen.width >= 768) {
        offset = 0;
        withTimeout = false;
    }

    let url = window.location.href, idx = url.indexOf("#");
    let hash = idx != -1 ? url.substring(idx + 1) : "";

    let scrollTo;

    if (hash !== "") {
        scrollTo = '#' + hash;
        withTimeout = false;
    } else {
        if (screen.width >= 768) {
            return;
        }

        scrollTo = '#main-headline';
    }

    if (!$(scrollTo).length) {
        return;
    }

    if (withTimeout) {
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $(scrollTo).offset().top - offset
            }, duration, 'swing');
        }, 1);
    } else {
        $('html, body').animate({
            scrollTop: $(scrollTo).offset().top - offset
        }, duration, 'swing');
    }
}

window.addEventListener('DOMContentLoaded', function () {
    (function ($) {
        $('.smooth-scroll').on('click', function (e) {
            e.preventDefault();

            let destination = $(this.hash);

            if (!destination.length) {
                return;
            }

            let offset = 0;

            if (screen.width < 768) {
                offset = 140;
            }

            if (e.target.dataset.offset) {
                offset = e.target.dataset.offset;
            }

            let animationDuration = 2000;

            if (e.target.dataset.duration) {
                animationDuration = parseInt(e.target.dataset.duration);
            }

            let scrollPosition = destination.offset().top - offset;

            $('html, body').animate({
                scrollTop: scrollPosition
            }, animationDuration);
        });
    })(jQuery);
});

window.descriptionReadMore = function() {
    var trigger = $('.description-read-more');

    trigger.on('click', function(e) {
        $(this).closest('.restaurant-description').removeClass('description-truncate-wrapper');
    });
}

window.feedbackReadMore = function () {
    const feedbackContainers = document.querySelectorAll('.feedback-container');

    feedbackContainers.forEach(container => {
        const content = container.querySelector('.feedback-content');
        const readMoreBtn = container.querySelector('.feedback-read-more-btn');

        const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
        const maxHeight = lineHeight * 2;
        const actualHeight = content.scrollHeight;

        if (actualHeight > maxHeight) {
            readMoreBtn.classList.remove('hidden');

            readMoreBtn.addEventListener('click', (e) => {
                e.preventDefault();
                content.classList.add('expanded');
                readMoreBtn.classList.add('hidden');
            });
        }
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/app.v2.js